import { render, staticRenderFns } from "./GuidelineForm.vue?vue&type=template&id=2c4c9d20&scoped=true&"
import script from "./GuidelineForm.vue?vue&type=script&lang=js&"
export * from "./GuidelineForm.vue?vue&type=script&lang=js&"
import style0 from "./GuidelineForm.vue?vue&type=style&index=0&id=2c4c9d20&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4c9d20",
  null
  
)

export default component.exports